import { takeLatest, put, call, select, take } from 'redux-saga/effects';

import {
  getTemplatesIfNeeded,
  getPaginatedTemplatesIfNeeded,
  getMinimalQueryTemplatesIfNeeded,
  getTemplateIfNeeded,
  createTemplateFromCurrent,
  updateTemplateFromCurrent,
  deleteTemplatesByIdList,
  warnAndArchive,
  getRecipientCountRequestIdIfNeeded,
  getListsRecipientCountIfNeeded,
  startPollingIfNeeded,
  getRecipientDetailsIfNeeded
} from './sagas';
import {
  GET_QUERY_TEMPLATES,
  GET_PAGINATED_QUERY_TEMPLATES,
  GET_MINIMAL_QUERY_TEMPLATES,
  GET_QUERY_TEMPLATE,
  CREATE_QUERY_TEMPLATE,
  CREATING_QUERY_TEMPLATE_SUCCEEDED,
  UPDATE_QUERY_TEMPLATE,
  UPDATING_QUERY_TEMPLATE_SUCCEEDED,
  DELETE_QUERY_TEMPLATES,
  getQueryTemplates,
  CREATING_QUERY_TEMPLATE_FAILED,
  UPDATING_QUERY_TEMPLATE_FAILED,
  GETTING_QUERY_TEMPLATE_FAILED,
  GETTING_QUERY_TEMPLATES_FAILED,
  DELETING_QUERY_TEMPLATES_FAILED,
  WARN_AND_ARCHIVE_QUERY_TEMPLATE,
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED,
  getPaginatedQueryTemplates,
  GET_RECIPIENT_COUNT_REQUEST_ID,
  GET_LISTS_RECIPIENT_COUNT,
  START_POLLING,
  GET_RECIPIENT_DETAILS,
  DELETING_QUERY_TEMPLATES_SUCCEEDED
} from './actions';
import { actions as UserActions } from '../user';
import { actions as userMessaging } from '../userMessaging';

/* Helper Sagas */
function* forceGetAllTemplates() {
  yield put(getQueryTemplates({ force: true }));
  yield put(getPaginatedQueryTemplates({ force: true }));
}
function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* HandleFailuresSaga() {
  yield takeLatest(
    [
      CREATING_QUERY_TEMPLATE_FAILED,
      UPDATING_QUERY_TEMPLATE_FAILED,
      GETTING_QUERY_TEMPLATE_FAILED,
      GETTING_QUERY_TEMPLATES_FAILED,
      DELETING_QUERY_TEMPLATES_FAILED,
      GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_FAILED
    ],
    function*(action) {
      yield put(
        userMessaging.setMessageForFailedAction({
          type: action.type,
          error: action.payload
        })
      );
    }
  );
}

/* APP FLOW - Templates */
function* QueryTemplateGetManySaga() {
  yield takeLatest(GET_QUERY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getTemplatesIfNeeded, action);
  });
}
function* PaginatedQueryTemplateGetManySaga() {
  yield takeLatest(GET_PAGINATED_QUERY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedTemplatesIfNeeded, action);
  });
}
function* MinimalQueryTemplateGetManySaga() {
  yield takeLatest(GET_MINIMAL_QUERY_TEMPLATES, function*(action) {
    yield call(waitForUserReady);
    yield call(getMinimalQueryTemplatesIfNeeded, action);
  });
}
function* QueryTemplateGetSingleSaga() {
  yield takeLatest(GET_QUERY_TEMPLATE, function*(action) {
    yield call(waitForUserReady);
    yield call(getTemplateIfNeeded, action);
  });
}
function* QueryTemplateGetRecipientDetailsSaga() {
  yield takeLatest(GET_RECIPIENT_DETAILS, function*(action) {
    yield call(getRecipientDetailsIfNeeded, action);
  });
}
function* QueryTemplateGetRecipientCountRequestIdSaga() {
  yield takeLatest(
    GET_RECIPIENT_COUNT_REQUEST_ID,
    getRecipientCountRequestIdIfNeeded
  );
}
function* QueryTemplateGetListsRecipientCountSaga() {
  yield takeLatest(GET_LISTS_RECIPIENT_COUNT, getListsRecipientCountIfNeeded);
}
function* QueryPollGetListsRecipientCountSaga() {
  yield takeLatest(START_POLLING, startPollingIfNeeded);
}
function* QueryTemplateCreateSuccessSaga() {
  yield takeLatest(CREATING_QUERY_TEMPLATE_SUCCEEDED, forceGetAllTemplates);
}
function* QueryTemplateUpdateSuccessSaga() {
  yield takeLatest(UPDATING_QUERY_TEMPLATE_SUCCEEDED, forceGetAllTemplates);
}
function* QueryTemplateDeleteSuccessSaga() {
  yield takeLatest(DELETING_QUERY_TEMPLATES_SUCCEEDED, forceGetAllTemplates);
}

// brutally refresh to template list on any modification - this *could* be made to act just on the in-memory reducer instead.
function* QueryTemplateCreateSaga() {
  yield takeLatest(CREATE_QUERY_TEMPLATE, createTemplateFromCurrent);
}
function* QueryTemplateUpdateSaga() {
  yield takeLatest(UPDATE_QUERY_TEMPLATE, updateTemplateFromCurrent);
}
function* WarnAndArchiveQueryTemplate() {
  yield takeLatest(WARN_AND_ARCHIVE_QUERY_TEMPLATE, warnAndArchive);
}

function* QueryTemplateDeleteSaga() {
  yield takeLatest(DELETE_QUERY_TEMPLATES, function*(action) {
    yield call(deleteTemplatesByIdList, action);
    // yield call(forceGetAllTemplates); // force refresh even if the delete is unsuccessful - since we don't know if we only partially failed.
  });
}

export default [
  QueryTemplateGetManySaga,
  PaginatedQueryTemplateGetManySaga,
  MinimalQueryTemplateGetManySaga,
  QueryTemplateGetSingleSaga,
  QueryTemplateCreateSaga,
  QueryTemplateUpdateSaga,
  QueryTemplateDeleteSaga,
  HandleFailuresSaga,
  WarnAndArchiveQueryTemplate,
  QueryTemplateCreateSuccessSaga,
  QueryTemplateUpdateSuccessSaga,
  QueryTemplateDeleteSuccessSaga,
  QueryTemplateGetRecipientCountRequestIdSaga,
  QueryTemplateGetListsRecipientCountSaga,
  QueryPollGetListsRecipientCountSaga,
  QueryTemplateGetRecipientDetailsSaga
];
